import { createSelector } from "reselect";

import ChatMessageRole from "@mapmycustomers/shared/enum/chat/ChatMessageRole";
import ChatUserMessageStatus from "@mapmycustomers/shared/enum/chat/ChatUserMessageStatus";

import { RootState } from "@app/store/rootReducer";

const chatConversationState = (state: RootState) => state.chat.conversation;

export const getChatConversationId = createSelector(
  chatConversationState,
  ({ conversationId }) => conversationId
);

export const getChatMessages = createSelector(chatConversationState, ({ messages }) => messages);

export const getChatSuggestions = createSelector(
  chatConversationState,
  ({ suggestions }) => suggestions
);

export const getChatProposalUi = createSelector(
  chatConversationState,
  ({ proposalUi }) => proposalUi
);

export const getChatProposalApply = createSelector(
  chatConversationState,
  ({ proposalApply }) => proposalApply
);

// Derived rather than stored: a turn is in flight exactly while one of our own messages is
// still sending. A second source of truth here could disagree with the messages it describes.
// The whole thread is scanned, not just the newest message, because a retry puts a message
// that is not last back into SENDING — and a tail-only guard would leave the composer enabled
// for a second concurrent POST on a conversation BE has already locked for the turn.
export const isChatTurnInProgress = createSelector(getChatMessages, (messages) =>
  messages.some(
    (message) =>
      message.role === ChatMessageRole.USER && message.status === ChatUserMessageStatus.SENDING
  )
);
